import Response from "../../Data/Domain/Response";
import User from "../Domain/User";
import Years from "../Domain/Years";

import {
  getUsers,
  getUser,
  deleteUser,
  updateEnabledUser,
  updateLumens,
  updateUserStatus,
  patchUser,
  getYearsByUser 
} from "./User.service";

export async function getUsersRepository(params) {
  const data = await getUsers(params);
  return new Response(data, User).getMultiple();
}

export async function getUserRepository(id) {
  const data = await getUser(id);
  return new Response(data, User).getSingle();
}

export async function deleteUserRepository(id, params) {
  const data = await deleteUser(id, params);
  return new Response(data, User).onlyStatus();
}

export async function updateEnabledRepository(id, params) {
  const data = await updateEnabledUser(id, params);
  return new Response(data, User).onlyStatus();
}

export async function updateLumensRepository(id, params) {
  const data = await updateLumens(id, params);
  return new Response(data, User).onlyStatus();
}

export async function updateUserStatusRepository(userId, verifiedStatus) {
  const data = await updateUserStatus(userId, verifiedStatus);
  return new Response(data, User).onlyStatus();
}
export async function patchUserRepository(id, params) {
  const data = await patchUser(id, params);
  if (data?.status === 204 || data?.status === 200) {
    return true;
  }
  if (typeof data === "object" && "statusText" in data) {
    return data.status === 204 || data.status === 200;
  }
  return false;
}
export async function getYearsByUserRepository(id) {
  const data = await getYearsByUser(id);
  const { resources } = new Response(data, Years).getMultiple();
  const years = resources.map(y => y.year);
  return years;
}